module.exports = __webpack_public_path__ + "static/media/ic-caret-up.8659ff75.svg";